import { isUploadableToSpace, MAX_SPACE_FILE_SIZE_BYTES } from 'shared';
import { z } from 'zod';

import { getTranslation } from '../../../utils/get-translation.util';
import { spaceFileNameSchema } from './create-folder.validation';

const BYTES_IN_MB = 1024 * 1024;

// Checked before a file is sent, with the rules and wording the server applies to it.
export const uploadFileSchema = z.object({
  name: spaceFileNameSchema,
  size: z
    .number()
    .positive({ message: getTranslation('SPACE_FILE_EMPTY') })
    .max(MAX_SPACE_FILE_SIZE_BYTES, {
      message: getTranslation('SPACE_FILE_TOO_LARGE', {
        max: MAX_SPACE_FILE_SIZE_BYTES / BYTES_IN_MB,
      }),
    }),
  type: z
    .string()
    .refine(isUploadableToSpace, { message: getTranslation('SPACE_FILE_UNSUPPORTED_TYPE') }),
});
